import { createSlice } from "@reduxjs/toolkit";
import { cps } from "redux-saga/effects";

const initialState = {
  loading: false,
  removeCommentSuccessIds: { postId: null, commentId: null },
  toxicheck: true,
  userToken: null,
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    removeCommentLoad: (state, action) => {
      state.loading = true;
      state.removeCommentSuccessIds = {
        postId: action.payload.postId,
        commentId: null,
      };
    },
    removeCommentSuccess: (state, action) => {
      state.loading = false;
      state.removeCommentSuccessIds = {
        ...state.removeCommentSuccessIds,
        commentId: action.payload,
      };
    },
    removeCommentFail: (state) => {
      state.loading = true;
      state.removeCommentSuccessIds = { postId: null, commentId: null };
    },
    resetCommentReducerState: (state) => {
      state.loading = true;
      state.removeCommentSuccessIds = { postId: null, commentId: null };
    },

    toxicLoad: (state, action) => {
      state.toxicheck = true;
    },

    toxicSuccess: (state, action) => {
      console.log(action.payload, "action ");

      state.toxicheck = action.payload;
    },

    toxicError: (state, action) => {
      state.toxicheck = true;
    },
    setUserToken: (state, action) => {
      state.userToken = action.payload;
    },
  },
});

export const {
  removeCommentLoad,
  removeCommentSuccess,
  removeCommentFail,
  toxicError,
  toxicLoad,
  toxicSuccess,
  setUserToken
} = commonSlice.actions;
export const selectToken = (state) => state.referralReducer.userToken;

export default commonSlice.reducer;
